import {
  ISolicitation,
  IMaintenanceCatalog,
  IMaintenanceRequest,
  IMaintenanceResponse,
  IMaintenanceHistoryItem,
  IMaintenanceHistoryPage,
} from '../../types/Equipaments';
import AxiosService from '../AxiosService';

const EquipamentsGet = async (clientCode: string): Promise<ISolicitation> => {
  const instance = AxiosService.createAuthAxiosInstance();
  const response = await instance.get('v1/client/equipments', {
    headers: {
      'client-code': clientCode,
    },
  });
  return response.data;
};

const UpdatedEquipamentsGet = async (clientCode: string): Promise<ISolicitation> => {
  const instance = AxiosService.createAuthAxiosInstance();
  const response = await instance.get('v1/client/updated-equipments', {
    headers: {
      'client-code': clientCode,
    },
  });
  return response.data;
};

const EquipmentRequest = async (data: object): Promise<ISolicitation> => {
  const instance = AxiosService.createAuthAxiosInstance();
  return instance.post('/v1/client/request/equipment', data);
};

const RequestEquipmentList = async (): Promise<any> => {
  return AxiosService
    .createAuthAxiosInstance()
    .get('/v1/client/request/equipment?paged=0&canceled=0');
};

const UpdateEquipmentRequestStatus = async (id: number|string, data: any): Promise<any> => {
  return AxiosService
    .createAuthAxiosInstance()
    .put(`/v1/client/request/equipment/${id}`, data);
}

/**
 * lista de tipos de defeitos
 */
const RequestEquipmentIssuesList = async (): Promise<any> => {
  return AxiosService
    .createAuthAxiosInstance()
    .get('/v1/client/request/equipment-maintenance/issues');
};

const RequestAvaliableMaintenanceTimes = async (): Promise<any> => {
  return AxiosService
    .createAuthAxiosInstance()
    .get('/v1/client/request/equipment-maintenance/avaliable-maintenance-times');
};

const VerifyGebra = async (gebra: string): Promise<any> => {
  return AxiosService
    .createAuthAxiosInstance()
    .get(`/v1/client/request/equipment-maintenance/verify-gebra/${gebra}`);
};

const RequestEquipmentMaintenance = async (request:any): Promise<any> => {
  return AxiosService
    .createAuthAxiosInstance()
    .post('/v1/client/request/equipment-maintenance', request);
};

const EquipmentMaintenanceList = async (): Promise<{data:{data:any[], links: any, meta:any}}> => {
  return AxiosService
    .createAuthAxiosInstance()
    .get('/v1/client/request/equipment-maintenance');
};

const CancelEquipmentMaintenance = async (item:any): Promise<any> => {
  return AxiosService
    .createAuthAxiosInstance()
    .put(`/v1/client/request/equipment-maintenance/change-status/${item.id}`, {
      status: 'cancelado'
    });
};

/**
 * Novo fluxo SAB — catálogo do formulário de manutenção.
 * GET /v1/client/request/maintenance/catalog
 */
const MaintenanceCatalog = async (): Promise<{data: IMaintenanceCatalog}> => {
  return AxiosService
    .createAuthAxiosInstance()
    .get('/v1/client/request/maintenance/catalog');
};

/**
 * Novo fluxo SAB — registra o(s) chamado(s). Cada defeito abre 1 protocolo.
 * POST /v1/client/request/maintenance
 */
const RequestMaintenance = async (
  request: IMaintenanceRequest,
): Promise<{data: IMaintenanceResponse}> => {
  return AxiosService
    .createAuthAxiosInstance()
    .post('/v1/client/request/maintenance', request);
};

/**
 * Novo fluxo SAB — histórico paginado (Laravel). GET /v1/client/request/maintenance
 * params opcionais: per_page, paged (0 = array puro), status (status_id), gebra.
 */
const MaintenanceHistoryList = async (
  params?: {per_page?: number; paged?: number; status?: number; gebra?: string},
): Promise<{data: IMaintenanceHistoryPage}> => {
  return AxiosService
    .createAuthAxiosInstance()
    .get('/v1/client/request/maintenance', {params});
};

/** Novo fluxo SAB — detalhe. GET /v1/client/request/maintenance/{id} */
const MaintenanceHistoryDetail = async (
  id: number | string,
): Promise<{data: IMaintenanceHistoryItem}> => {
  return AxiosService
    .createAuthAxiosInstance()
    .get(`/v1/client/request/maintenance/${id}`);
};

export default {
  EquipamentsGet,
  MaintenanceCatalog,
  RequestMaintenance,
  MaintenanceHistoryList,
  MaintenanceHistoryDetail,
  UpdatedEquipamentsGet,
  EquipmentRequest,
  RequestEquipmentList,
  UpdateEquipmentRequestStatus,
  RequestEquipmentIssuesList,
  RequestAvaliableMaintenanceTimes,
  RequestEquipmentMaintenance,
  EquipmentMaintenanceList,
  CancelEquipmentMaintenance,
  VerifyGebra
};
